import Marionette from 'backbone.marionette';

import template from './SwitchMapModeView.hbs';
import { setSearchParam } from 'eoxc/src/core/util';

const SwitchMapModeView = Marionette.ItemView.extend({
  template,
  templateHelpers() {
    return {
      enable3D: this.mapModel.get('mapMode') === '3D',
    };
  },
  events: {
    'click .changeMapMode': 'onMapModeChange',
  },
  initialize(options) {
    this.mapModel = options.mapModel;
    this.initialMapMode = options.initialMapMode;
  },
  onMapModeChange() {
    if (this.mapModel.get('mapMode') === '2D') {
      this.mapModel.set('mapMode', '3D');
    } else {
      this.mapModel.set('mapMode', '2D');
    }
    const saveMapMode = this.initialMapMode !== this.mapModel.get('mapMode') ? this.mapModel.get('mapMode') : null;
    setSearchParam('mapMode', saveMapMode);
    this.render();
  }
});

export default SwitchMapModeView;



// WEBPACK FOOTER //
// /src/views/SwitchMapModeView.js